import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-grape/15 bg-white p-5 shadow-[0_12px_30px_-24px_rgba(46,16,101,0.45)]" data-id="element-185" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-186" data-mp="345h26d0kwcdg">
        <img src={testimonial.img} alt={testimonial.name} className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-grape/40" data-id="element-187" data-mp="3872hs64hz4rc" />
        <div className="min-w-0" data-id="element-188" data-mp="1dsjhma7fhdch">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-189" data-mp="1drrn72pkhlns">
            <span className="text-sm font-bold text-plum" data-id="element-190" data-mp="hskrct071m5o">{testimonial.name}</span>
            <span className="flex gap-0.5 text-blush" aria-label="5 étoiles sur 5" data-id="element-191" data-mp="hunmtsk487hs">
              {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-192" data-mp="842uunyy617u" data-mpi={k} />)}
            </span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-plum/55" data-id="element-193" data-mp="35htumbvfdic">
            <span data-id="element-194" data-mp="10qnjvhrya188">📍 {testimonial.location}</span>
            <span className="text-sm leading-none" aria-hidden="true" data-id="element-195" data-mp="10pcg3hyi8th4">
              {testimonial.flag}
            </span>
          </div>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-grape/10 pt-4 text-[15px] leading-relaxed text-plum/75" data-id="element-196" data-mp="qry2rr7vokt1">
        “{testimonial.quote}”
      </blockquote>
    </motion.figure>;
}